import { RouterSelectors } from '@next/core-lib/router-store';
import { createSelector } from '@ngrx/store';

import { getSelectedCycle } from './cycle.selectors';
import { Barn, DayOldChick } from '../../models/cycle.model';

export const getDayOldChicks = createSelector(getSelectedCycle, (cycle) =>
  !!cycle && !!cycle.dayOldChicks
    ? cycle.dayOldChicks.slice().sort((a, b) => (a.arrivalDate > b.arrivalDate ? 1 : -1))
    : undefined,
);

export const hasDayOldChicks = createSelector(
  getDayOldChicks,
  (dayOldChicks) => !!dayOldChicks && dayOldChicks.length > 0,
);

export const getNextDayOldChickId = createSelector(getDayOldChicks, (dayOldChicks) =>
  !!dayOldChicks && dayOldChicks.length > 0 ? Math.max(...dayOldChicks.map((d) => d.id)) + 1 : 1,
);

export const getSelectedDayOldChickId = createSelector(RouterSelectors.getMergedRoute, (state) =>
  !isNaN(parseInt(state.params['dayOldChickId'], 10))
    ? parseInt(state.params['dayOldChickId'], 10)
    : undefined,
);

export const getSelectedDayOldChick = createSelector(
  getSelectedDayOldChickId,
  getDayOldChicks,
  (dayOldChickId: number, dayOldChicks: DayOldChick[]) =>
    dayOldChicks ? dayOldChicks.find((d) => d.id === dayOldChickId) : undefined,
);

export const getPreviousDayOldChick = createSelector(
  getDayOldChicks,
  (dayOldChicks) =>
    !!dayOldChicks &&
    dayOldChicks.length > 0 &&
    dayOldChicks.reduce((prev, curr) => (prev.id > curr.id ? prev : curr)),
);

export const getBarnsInUse = createSelector(getDayOldChicks, (dayOldChicks) =>
  dayOldChicks
    ? dayOldChicks
        .reduce((acc: Barn[], curr) => [...acc, curr.barn], [])
        .filter((b1, pos, arr) => arr.findIndex((b2) => b2.id === b1.id) === pos)
        .sort((a, b) => (a.name > b.name ? 1 : -1))
    : undefined,
);

export const sumAmountOfChicksByBarn = createSelector(
  getDayOldChicks,
  (dayOldChicks) => (barnId: number) =>
    dayOldChicks.reduce(
      (acc: number, d: DayOldChick) => (d.barn.id === barnId ? acc + d.amountOfChicks : acc),
      0,
    ),
);

export const sumAmountOfChicksExcludeCurrentDayOldChick = createSelector(
  getDayOldChicks,
  getSelectedDayOldChickId,
  (dayOldChicks, selectedDayOldChickId) => (barnId: number) =>
    dayOldChicks
      ? dayOldChicks.reduce(
          (acc: number, d: DayOldChick) =>
            d.id !== selectedDayOldChickId && d.barn.id === barnId ? acc + d.amountOfChicks : acc,
          0,
        )
      : 0,
);
